import React from "react";
import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../helper/Preloader";

import AdminSellerRegisCompleted from "../../components/seller-registration/adminregistration/CompletedScreen";

const AdminSellerRegisCompletedPage = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color='#990A02' />

      {/* Preloader */} 
      <Preloader />

      <AdminSellerRegisCompleted />

    </>
  );
};

export default AdminSellerRegisCompletedPage;